module.exports = __webpack_public_path__ + "img/in_house_finance_professional.13beb3ff.svg";